import { StyleSheet } from 'react-native';

import maxContainerWidthStyle from '../../../../styles/max-container-width/max-container-width.style';

export default StyleSheet.create({
  content: {
    ...maxContainerWidthStyle,
    paddingHorizontal: 16,
  },
  image: {
    marginTop: 16,
  },
  answersContainer: {
    paddingVertical: 40,
    marginTop: 22,
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  optionsContainer: {
    paddingTop: 40,
    paddingBottom: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  optionsInnerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: 1400,
    flexWrap: 'wrap',
    paddingHorizontal: 8,
  },
  instructions: {
    marginVertical: 16,
    textAlign: 'center',
    alignItems: 'center',
  },
  audioPlayer: {
    paddingBottom: 20,
    paddingTop: 0,
  },
  placeholderStyle: {
    width: 110,
  },
  hintButton: {
    marginTop: 16,
    marginBottom: -16,
  },
});
